import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { QRCodeWrapperModule } from '../shared/qrcode-wrapper.module';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../core/auth.guard';

import {
  ExceptionLogListComponent,
  ExceptionLogViewComponent,
  SystemStatusComponent,
  BackupsListComponent,
  AppliedPatchesComponent,
  OnDemandTasksComponent,
  WebSiteRequestsComponent,
  WebSiteListComponent,
  WebSiteViewComponent
} from '.';
function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
  }
}


const routes: Routes = [
  { path: 'exceptionlog', component: ExceptionLogListComponent, canActivate: [AuthGuard] },
  { path: 'exceptionlog/:ID', component: ExceptionLogViewComponent, canActivate: [AuthGuard] },
  { path: 'systemstatus', component: SystemStatusComponent, canActivate: [AuthGuard] },
  { path: 'developer/appliedpatches', component: AppliedPatchesComponent, canActivate: [AuthGuard] },
  { path: 'developer/ondemandtasks', component: OnDemandTasksComponent, canActivate: [AuthGuard] },
  { path: 'developer/backups', component: BackupsListComponent, canActivate: [AuthGuard] },
  { path: 'developer/websites', component: WebSiteListComponent, canActivate: [AuthGuard] },
  { path: 'developer/websites/:ID', component: WebSiteViewComponent, canActivate: [AuthGuard] },
  { path: 'developer/websitesrequests', component: WebSiteRequestsComponent, canActivate: [AuthGuard] },

];

const pages = [
  ExceptionLogListComponent,
  ExceptionLogViewComponent,
  SystemStatusComponent,
  BackupsListComponent,
  AppliedPatchesComponent,
  OnDemandTasksComponent,
  WebSiteRequestsComponent,
  WebSiteListComponent,
  WebSiteViewComponent
]; 

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    QRCodeWrapperModule,
    NgxChartsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    ...pages
  ],
  providers: []
})
export class DeveloperModule { 
  constructor(@Optional() @SkipSelf() parentModule: DeveloperModule) {
    if (parentModule) {
      throw new Error('Module is already loaded. Import in your base AppModule only.');
    }
  }
}
